var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{staticClass:"loading-spinner",attrs:{"indeterminate":"","color":"#8e84c0","size":"60","width":"3"}},[_c('v-img',{attrs:{"src":_vm.Logo,"height":"33px","width":"33px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }